export default __webpack_public_path__ + "static/media/deposit-gpay-step5.9dff6989.png";